import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { TURN_OS_VACANCIES_URL, turnOsProjectUrl } from 'lib/turn-os'

export default function RetiredProjectsRedirect() {
  const { constructionProjectId } = useParams<{ constructionProjectId?: string }>()
  useEffect(() => {
    window.location.replace(
      constructionProjectId ? turnOsProjectUrl(constructionProjectId) : TURN_OS_VACANCIES_URL
    )
  }, [constructionProjectId])
  return <p>Opening Turn OS…</p>
}
